import React, { Component } from 'react'
import { Tab, TabList, TabPanel } from 'react-tabs'
import { connect } from 'react-redux'
import { compose } from 'redux';

import { selectIsRequestPending, requireLogin } from '../util/index'
import { Container, PageHeader, PageTitle, PageSpinner, Link, Button, RoutedTabs } from '../components/index.js'
import UserEmulator from './tools/userEmulator/UserEmulator'

class AdminTools extends Component {

    // handleTabSwitch = (newTabIndex, oldTabIndex) => {
    //     if (newTabIndex !== oldTabIndex) {
    //       history.push(history.location.pathname + (newTabIndex === 1 ? '?tab=tool3' : ''))
    //     }
    // }

    render () {
        let {} = this.props
        return (
            <div>
            <PageTitle title='Admin Tools' />
            <PageHeader title='Admin Tools' back={<Link to={'/'} className='page-title-back'>&lt; Home</Link>}>                
            </PageHeader>

            <Container section>
                <RoutedTabs tabs={['UserEmulator', 'futureTool2']}>
                    <TabList>
                        <Tab>User Emulator</Tab>
                        <Tab>Future Tool 2</Tab>
                    </TabList>

                    <TabPanel>
                        <UserEmulator />
                    </TabPanel>

                    <TabPanel>
                        <div>Place Holder for Future Tool 2 component</div>
                    </TabPanel>
                </RoutedTabs>
            </Container>
            </div>
        )
    }

}

export default compose(
    requireLogin('Admin'),
    connect((state, ownProps) => {
    return {      
    }
  }, {  }))(AdminTools)


// WEBPACK FOOTER //
// ./client/src/admin/admin.js